import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ChevronLeft } from '@montel/montelpro-shared-components/assets/icons/icons_navigation/chevron_left_24dp.svg';
import styles from './backButton.module.scss';

const BackButton: FunctionComponent = () => {
	const navigate = useNavigate();

	return (
		<>
			{history?.length && (
				<div className={styles.backButton}>
					<a onClick={() => navigate(-1)}>
						<ChevronLeft />
						<span>Back</span>
					</a>
				</div>
			)}
		</>
	);
};

export default BackButton;
